import { BrandclubEventType } from './types.js';

var timeoutPromise = function (ms, name, fn) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(new Error("".concat(name, " timed out after ").concat(ms, "ms")));
        }, ms);
        fn().then(resolve, reject);
    });
};
function mapAppEventToExternalCustomEvent(eventType, supportedEventsConfig) {
    var _a, _b, _c, _d;
    if (!supportedEventsConfig) {
        return undefined;
    }
    // Page View events
    if (((_a = supportedEventsConfig.pageView) === null || _a === void 0 ? void 0 : _a.enabled) &&
        ((eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('page view')) || (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('bc_checkout_page_view')))) {
        return {
            eventName: supportedEventsConfig.pageView.mappedEventName,
            eventType: BrandclubEventType.PageView,
        };
    }
    // Navigate to Retailer events
    if (((_b = supportedEventsConfig.navigateToRetailer) === null || _b === void 0 ? void 0 : _b.enabled) &&
        (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('openRetailerProductPage'))) {
        return {
            eventName: supportedEventsConfig.navigateToRetailer.mappedEventName,
            eventType: BrandclubEventType.NavigateToRetailer,
        };
    }
    // Add to Cart events
    if (((_c = supportedEventsConfig.addToCart) === null || _c === void 0 ? void 0 : _c.enabled) &&
        (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith(':addToCart'))) {
        return {
            eventName: supportedEventsConfig.addToCart.mappedEventName,
            eventType: BrandclubEventType.AddToCart,
        };
    }
    // Order Submitted events
    if (((_d = supportedEventsConfig.orderSubmitted) === null || _d === void 0 ? void 0 : _d.enabled) &&
        (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('bc_checkout_order_submit'))) {
        return {
            eventName: supportedEventsConfig.orderSubmitted.mappedEventName,
            eventType: BrandclubEventType.OrderSubmitted,
        };
    }
    return undefined;
}
function parseEventAndPayload(eventName, payload, supportedEventsConfig) {
    var _a;
    var mappedEvent = mapAppEventToExternalCustomEvent(eventName, supportedEventsConfig);
    if (!(mappedEvent === null || mappedEvent === void 0 ? void 0 : mappedEvent.eventName) || !(mappedEvent === null || mappedEvent === void 0 ? void 0 : mappedEvent.eventType)) {
        return {
            eventName: undefined,
            eventPayload: {},
        };
    }
    var externalEventName = mappedEvent.eventName, eventType = mappedEvent.eventType;
    var convertedPayload = JSON.parse(JSON.stringify({
        stacklineSku: (payload === null || payload === void 0 ? void 0 : payload.sku) || (payload === null || payload === void 0 ? void 0 : payload.stacklineSku),
        retailerId: payload === null || payload === void 0 ? void 0 : payload.retailerId,
        retailerSku: payload === null || payload === void 0 ? void 0 : payload.retailerSku,
        retailPrice: payload === null || payload === void 0 ? void 0 : payload.retailPrice,
        pageId: payload === null || payload === void 0 ? void 0 : payload.pageId,
        pageType: payload === null || payload === void 0 ? void 0 : payload.pageType,
        brandId: payload === null || payload === void 0 ? void 0 : payload.brandId,
        brandName: payload === null || payload === void 0 ? void 0 : payload.brandName,
        categoryId: payload === null || payload === void 0 ? void 0 : payload.categoryId,
        categoryName: payload === null || payload === void 0 ? void 0 : payload.categoryName,
        subCategoryId: payload === null || payload === void 0 ? void 0 : payload.subCategoryId,
        subCategoryName: payload === null || payload === void 0 ? void 0 : payload.subCategoryName,
        jl_id: payload === null || payload === void 0 ? void 0 : payload.jl_id,
        jl_c: payload === null || payload === void 0 ? void 0 : payload.jl_c,
        jl_m: payload === null || payload === void 0 ? void 0 : payload.jl_m,
        jl_s: payload === null || payload === void 0 ? void 0 : payload.jl_s,
        checkoutItems: (_a = payload === null || payload === void 0 ? void 0 : payload.checkoutItems) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
            retailerId: item.retailerId,
            retailerSku: item.retailerSku,
            stacklineSku: item.stacklineSku,
            quantity: item.quantity,
        }); }),
        checkoutIntentId: payload === null || payload === void 0 ? void 0 : payload.checkoutIntentId,
    }));
    return {
        eventName: externalEventName,
        eventType: eventType,
        eventPayload: convertedPayload,
    };
}

export { parseEventAndPayload, timeoutPromise };
//# sourceMappingURL=utils.js.map
